import MainPlayer from '@player/src/main/main';


class VliteMainplayer extends MainPlayer{
    _playerCreatorMap(playerType){
        switch(playerType){
          case 'dashPlayer':return ()=>import('@player/src/project_vlite/players/vlite_dashplayer.js');
          case 'hlsPlayer':return ()=>import('@player/src/players/hlsPlayer.js');
          case 'html5Player':return ()=>import('@player/src/players/html5Player.js');
          default:return Promise.reject('content type not supported.');
        }  
    }
}



export {VliteMainplayer as Mainplayer}